$(document).ready(function () {
  const card = $(".glossar .card");
  const close = $(".glossar .card .close-icon");
  const grid = $(".post-grid");
  const filter = $(".filter-group");

  // Funktion zum Öffnen einer Karte basierend auf ihrer ID
  function openCard(cardId) {
    const cardToOpen = $(`#${cardId}`);

    filter.fadeOut();
    card.removeClass("visible");
    card.removeClass("flipback");
    card.addClass("hidden");
    cardToOpen.removeClass("visible");
    cardToOpen.removeClass("hidden");
    cardToOpen.removeClass("flipback");

    grid.addClass("toggleGrid");

    setTimeout(() => {
      cardToOpen.addClass("flip");
    }, 1200);
  }

  // Funktion zum Schließen der geöffneten Karte
  function closeCard() {
    const openedCard = $(".glossar .card.flip");

    filter.fadeIn();
    openedCard.removeClass("flip");
    openedCard.addClass("flipback");
    $('audio').each(function () {
      $(this)[0].pause();
    });

    setTimeout(() => {
      card.removeClass("hidden");
      card.addClass("visible");
      grid.removeClass("toggleGrid");
      openedCard.removeClass("flipback");
    }, 1200);
  }

  card.on("click", function (e) {
    if (!$(this).hasClass("flipback")) {
      const cardId = this.id;
      history.pushState(null, '', '#' + cardId); // Ändere den Deep Link in der Adresszeile
      openCard(cardId);
    }
  });

  close.on("click", function (e) {
    closeCard();
    history.replaceState(null, '', window.location.pathname); // Entferne den Deep Link aus der Adresszeile
  });

  // Event-Listener für das hashchange-Event
  $(window).on("hashchange", function () {
    const hash = window.location.hash.substring(1); // Entferne das "#" aus dem Deep Link
    if (hash) {
      openCard(hash);
    } else {
      closeCard();
    }
  });

  // Event-Listener für das onpopstate-Event (Zurück-Button des Browsers)
  window.onpopstate = function (event) {
    if (!window.location.hash) {
      closeCard();
    }
  };

  // Öffne die Karte basierend auf dem Deep Link, wenn die Seite geladen wird
  const initialHash = window.location.hash.substring(1);
  if (initialHash) {
    openCard(initialHash);
  }
});
